var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';
const BDSMenuItemStyled = styled(MenuItem, { shouldForwardProp: prop => prop !== 'selected' })(({ theme, selected }) => (Object.assign(Object.assign({ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: theme.palette.menu.spaceBetween, backgroundColor: theme.palette.menuItem.background.color, borderColor: `${theme.palette.menuItem.border.width} solid ${theme.palette.menuItem.border.color}`, color: theme.palette.menuItem.text.color }, (selected && {
    backgroundColor: theme.palette.menuItem.background.selected.color,
    borderColor: `${theme.palette.menuItem.border.width} solid ${theme.palette.menuItem.border.selected.color}`,
    color: theme.palette.menuItem.text.selected,
    '&:hover': {
        backgroundColor: theme.palette.menuItem.background.selected.hover,
        borderColor: `${theme.palette.menuItem.border.width} solid ${theme.palette.menuItem.border.selected.hover}`,
        color: theme.palette.menuItem.text.selected
    }
})), { '&:hover': {
        backgroundColor: theme.palette.menuItem.background.hover,
        borderColor: `${theme.palette.menuItem.border.width} solid ${theme.palette.menuItem.border.hover}`,
        color: theme.palette.menuItem.text.hover
    }, '&.Mui-focusVisible': {
        backgroundColor: theme.palette.menuItem.background.focus,
        borderColor: `${theme.palette.menuItem.border.width} solid ${theme.palette.menuItem.border.focus}`,
        color: theme.palette.menuItem.text.focus
    }, '&.Mui-disabled': {
        color: theme.palette.menuItem.text.disabled,
        pointerEvents: 'none',
        backgroundColor: theme.palette.menuItem.background.disabled,
        borderColor: `${theme.palette.menuItem.border.width} solid ${theme.palette.menuItem.border.disabled}`
    }, borderRadius: theme.palette.menu.border.radius, padding: theme.palette.menuItem.padding.default })));
const BDSMenuItem = (_a) => {
    var { selected = false } = _a, props = __rest(_a, ["selected"]);
    return React.createElement(BDSMenuItemStyled, Object.assign({ selected: selected }, props));
};
BDSMenuItem.displayName = 'BDSMenuItem';
export default BDSMenuItem;
//# sourceMappingURL=MenuItem.js.map